import { render } from "./StudentSettingsPage.vue?vue&type=template&id=620a30ec"
import script from "./StudentSettingsPage.vue?vue&type=script&lang=js"
export * from "./StudentSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__